module.exports = {"graphQlEndpoint":"http://localhost:8000/graphql","restEndpointTest":"http://localhost:8000/api/portal","restEndpoint":"https://plugin.fourseasonstravelgroup.nl/api/portal","restEndpointOnlineTest":"http://95.85.53.177/api/portal"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 58
// module chunks = 1